export function financial(x) {
  return Number.parseFloat(x).toFixed(2);
}

export const calculatePercentage = (value, total) => {
  return (value / total) * 100 || 0;
};

export const formatPackageStatus = (data) => {
  // Safety check: ensure data is an array
  const inputData = Array.isArray(data) ? data : [];

  const defaultData = [
    {
      label: "order_received",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "order_confirmed",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "to_pick_up",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "picked_up",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "in_transit",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "arrived_at_warehouse",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "warehouse_processing",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "to_deliver",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "self_pickup_putaway",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "delivering",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "signed",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "abnormal_signed",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "return_collection",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
  ];

  const statusMap = new Map(inputData.map((item) => [item._id, item]));

  return defaultData.map((status) => {
    const dataItem = statusMap.get(status.label);
    if (!dataItem) return status;
    return {
      ...status,
      value: dataItem.count || 0,
      totalAmount: dataItem.totalAmount || 0,
      totalCost: dataItem.totalCost || 0,
      totalProfit: dataItem.totalProfit || 0,
    };
  });
};

export const formatPackageStatusMobile = (data) => {
  const defaultData = [
    {
      label: "order_received",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "in_transit",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "return_collection",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
    {
      label: "signed",
      value: 0,
      totalAmount: 0,
      totalCost: 0,
      totalProfit: 0,
    },
  ];

  const statusMap = new Map(data.map((item) => [item._id, item]));

  return defaultData.map((status) => {
    const dataItem = statusMap.get(status.label);
    if (!dataItem) return status;
    return {
      ...status,
      value: dataItem.count || 0,
      totalAmount: dataItem.totalAmount || 0,
      totalCost: dataItem.totalCost || 0,
      totalProfit: dataItem.totalProfit || 0,
    };
  });
};

export const formatInvoiceStatus = (data) => {
  const defaultStatuses = [
    { label: "pending", value: 0, totalAmount: 0, totalNet: 0 },
    { label: "paid", value: 0, totalAmount: 0, totalNet: 0 },
  ];

  const statusMap = new Map(
    data.map((item) => [
      item._id,
      {
        count: item.count,
        totalAmount: item.totalAmount,
        totalNet: item.totalNet,
      },
    ])
  );

  return defaultStatuses.map((status) => ({
    label: status.label,
    value: statusMap.get(status.label)?.count || status.value,
    totalNet: statusMap.get(status.label)?.totalNet || status.totalNet,
    totalAmount: statusMap.get(status.label)?.totalAmount || status.totalAmount,
  }));
};
